import PropTypes from "prop-types"
import { Link } from "react-scroll"
import classNames from "classnames/bind"
import BurgerBtn from "components/Header/components/Menu/components/BurgerBtn"
import useToggle from "hooks/useToggle"
import "./styles/navbar.scss"
import useMediaQuery from "hooks/useMediaQuery"
import { SM } from "consts/breakpoints"
import { BANNER_INFO } from "../../../Banner/constants"

export const Menu = ({ className, logo, items = [] }) => {
  const isMobile = useMediaQuery(SM)
  const [toggable, setToggable] = useToggle()

  const handleRenderArray = () =>
    items.map((item, i) => (
      <li className="main-menu-sections__section" key={`key_${item}`}>
        <div className="text-capitalize">
          <Link
            className="header-menu-button"
            activeClass="header-menu-button--active"
            to={i !== 0 ? item : BANNER_INFO.id}
            duration={100}
            offset={-50}
            smooth
            spy
          >
            {item}
          </Link>
        </div>
      </li>
    ))

  return (
    <div className="container">
      <div className="row g-0">
        <div className="col-3 col-md-10 order-md-1">
          <BurgerBtn toggable={toggable} setToggable={setToggable} />
          <div
            className={classNames({
              "header-main-menu": true,
              "header-main-menu--open": toggable,
              [className]: className && isMobile
            })}
          >
            <ul
              className={classNames({
                "main-menu-sections": true,
                "main-menu-sections--open": toggable
              })}
            >
              {handleRenderArray()}
            </ul>
          </div>
        </div>
        <div className="col-8 col-md-2 order-md-0">
          <Link to="home-slide" className="logo cursor-pointer" duration={100} smooth={true}>
            {logo && (
              <img
                className="img-fluid"
                src={logo}
                alt="Spradling Group"
                title="Spradling Group"
                width="150px"
                height="50px"
              />
            )}
          </Link>
        </div>
      </div>
    </div>
  )
}

Menu.propTypes = {
  className: PropTypes.string,
  logo: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string)
}

export default Menu
